import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";
import { Add, Edit } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
  Box,
  Chip,
  FormControl,
  InputLabel,
  Paper,
  SwipeableDrawer,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import jwtAuthAxios from "app/services/auth/jwtAuth";
import TableSkeleton from "app/shared/widgets/TableSkeleton";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import * as yup from "yup";
import moment from "moment";


const validationSchema = yup.object({
  FL_COID: yup.string().required("Coid is required"),
  FL_YRDT1: yup.string().required("Yrdt1 is required"),
  FL_YRDT2: yup.string().required("Yrdt2 is required"),
  FL_FIN_YEAR: yup.string().required("Fin Year is required"),
  FL_DEFAULT: yup.string().required("Default is required"),
});
const FinYears = () => {
  const [finYearsData, setFinYearsData] = useState([]);
  const [drawer, setDrawer] = useState(false);
  const [isedit, setIsedit] = useState(false);
  const [loading, setLoading] = useState(false);
  const { rights } = useJumboAuth();
  const swal = useSwalWrapper();

  const formik = useFormik({
    initialValues: {
      FL_COID: "",
      FL_YRDT1: "",
      FL_YRDT2: "",
      FL_FIN_YEAR: "",
      FL_DEFAULT: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      // console.log(values)
      setLoading(true);
      const endpoint = isedit
        ? `branch/branches/${values.branchCode}`
        : "branch/addbranch";
      try {
        const response = await jwtAuthAxios.post(endpoint, values);
        // console.log(response.data);
        if (response.data.status === "success") {
          fetchFinYearsData();
          setDrawer(false);
          swal.fire({
            icon: "success",
            text: response.data.message,
          });
        } else {
          swal.fire({
            icon: "error",
            text: response.data.message || "Something Went Wrong",
          });
        }
      } catch (error) {
        console.error(error);
        swal.fire({
          icon: "error",
          text: "Something Went Wrong",
        });
      } finally {
        setLoading(false);
      }
    },
  });

  const fetchFinYearsData = async () => {
    try {
      const response = await jwtAuthAxios.get("master/finyears");
      console.log("response.data", response.data);
      setFinYearsData(response.data.data);
    } catch (error) {
      console.error(error);
    }
  };


  useEffect(() => {
    fetchFinYearsData();
  }, []);
  useEffect(() => {
    if (drawer == false) {
      formik.resetForm();
      setIsedit(false);
    }
  }, [drawer]);

  const finYearEditHandler = (branch) => {
    formik.setValues({
      branchCode: branch?.FL_BRANCH_CODE || "",
      branchName: branch?.FL_BRANCH_NAME || "",
      address: branch?.FL_BRANCH_ADDR || "",
      company: branch?.FL_COMPANY_CODE || "",
      city: branch?.FL_BRANCH_CITY || "",
      country: branch?.FL_BRANCH_COUNTRY || "",
      FL_GST_NO: branch?.FL_GST_NO || "",
    });
    setIsedit(true);
    setDrawer(true);
  };

  return (
    <div>
      {rights?.insert == 1 && (
        <LoadingButton
          variant="contained"
          onClick={() => setDrawer(true)}
          sx={{ display: "flex", margin: "0 0px 22px auto" }}
          startIcon={<Add />}
          color="primary"
        >
          Add FinYears
        </LoadingButton>
      )}
      {finYearsData.length > 0 ? (
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Cold</TableCell>
                <TableCell>Yrdt1</TableCell>
                <TableCell>Yrdt2</TableCell>
                <TableCell>Fin Year</TableCell>
                <TableCell>Default</TableCell>
                <TableCell align="right">Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {finYearsData.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{item.FL_COID}</TableCell>
                  <TableCell>
                    {moment(item.FL_YRDT1).format("DD/MM/YYYY")}
                  </TableCell>
                  <TableCell>
                    {moment(item?.FL_YRDT2).format("DD/MM/YYYY")}
                  </TableCell>
                  <TableCell>{item?.FL_FIN_YEAR}</TableCell>
                  <TableCell>{item.FL_DEFAULT}</TableCell>
                  <TableCell align="right">
                    {rights?.edit == 1 && (
                      <Chip
                        color={"error"}
                        onClick={() => finYearEditHandler(item)}
                        icon={<Edit fontSize="18px" />}
                        label="edit"
                      />
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <TableSkeleton cols={7} />
      )}
      <SwipeableDrawer
        anchor="right"
        open={drawer}
        onClose={() => setDrawer(false)}
        onOpen={() => setDrawer(true)}
      >
        <Box
          component="form"
          sx={{
            display: "flex",
            flexDirection: "column",
            minWidth: "400px",
            margin: "0 auto",
            p: 3,
          }}
          onSubmit={formik.handleSubmit}
        >
          <h3 style={{ padding: "5px", marginTop: "0" }}>FinYear</h3>
          <TextField
            label="Coid"
            variant="outlined"
            margin="normal"
            fullWidth
            disabled={isedit}
            autoFocus
            {...formik.getFieldProps("FL_COID")}
            error={formik.touched.FL_COID && Boolean(formik.errors.FL_COID)}
            helperText={formik.touched.FL_COID && formik.errors.FL_COID}
          />
          {/* <DatePicker
            label="Yrdt1"
            format="MM/dd/yyyy"
            variant="outlined"
            margin="normal"
            fullWidth
            {...formik.getFieldProps("FL_YRDT1")}
            error={formik.touched.FL_YRDT1 && Boolean(formik.errors.FL_YRDT1)}
            helperText={formik.touched.FL_YRDT1 && formik.errors.FL_YRDT1}
          /> */}
          {/* <TextField
            label="Yrdt1"
            variant="outlined"
            margin="normal"
            fullWidth
            {...formik.getFieldProps("FL_YRDT1")}
            error={
              formik.touched.FL_YRDT1 && Boolean(formik.errors.FL_YRDT1)
            }
            helperText={formik.touched.FL_YRDT1 && formik.errors.FL_YRDT1}
          /> */}
          <TextField
            label="Yrdt2"
            variant="outlined"
            margin="normal"
            fullWidth
            {...formik.getFieldProps("FL_YRDT2")}
            error={formik.touched.FL_YRDT2 && Boolean(formik.errors.FL_YRDT2)}
            helperText={formik.touched.FL_YRDT2 && formik.errors.FL_YRDT2}
          />
          <FormControl variant="outlined" fullWidth margin="normal">
            <InputLabel id="company-label">Fin Year</InputLabel>
            {/* <DatePicker
              label="Select Date"
              // value={selectedDate}
              // onChange={handleDateChange}
              format="MM/dd/yyyy"
            /> */}
          </FormControl>
          <TextField
            label="City"
            variant="outlined"
            margin="normal"
            fullWidth
            {...formik.getFieldProps("city")}
            error={formik.touched.city && Boolean(formik.errors.city)}
            helperText={formik.touched.city && formik.errors.city}
          />
          <TextField
            label="Country"
            variant="outlined"
            margin="normal"
            fullWidth
            {...formik.getFieldProps("country")}
            error={formik.touched.country && Boolean(formik.errors.country)}
            helperText={formik.touched.country && formik.errors.country}
          />
          <TextField
            label="GST Number"
            variant="outlined"
            margin="normal"
            fullWidth
            {...formik.getFieldProps("FL_GST_NO")}
            error={formik.touched.FL_GST_NO && Boolean(formik.errors.FL_GST_NO)}
            helperText={formik.touched.FL_GST_NO && formik.errors.FL_GST_NO}
          />

          <LoadingButton
            loading={loading}
            type="submit"
            variant="contained"
            color="primary"
            sx={{ marginTop: "16px" }}
          >
            Submit
          </LoadingButton>
        </Box>
      </SwipeableDrawer>
    </div>
  );
};

export default FinYears;
FinYears.Modulename = "expensepayment";
